<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center height-fit-content fill-width mx-lg-5 px-lg-2 mx-2"
  >
    <template v-if="!noGateWayActive && !mobileSize">
      <b-container
        class="pb-4 mb-2 pt-4 m-1 direction-rtl tab-container-width"
        fluid
        v-if="!getGlobalApiRequestPending"
      >
        <b-row class="justify-content-center">
          <b-col cols="12" xl="11" align-self="center">
            <b-row class="d-flex justify-content-center">
              <template v-for="(tab, index) in filteredGateways">
                <b-col
                  :key="index"
                  align-self="center"
                  class="custom-tab-col"
                  @click="
                    goTo(
                      `/${
                        tab === 'shetab'
                          ? ''
                          : tab === 'cardToCard'
                          ? 'ctc'
                          : tab === 'cryptoGroup'
                          ? 'crypto-group'
                          : tab === 'indirectGroup'
                          ? 'indirect'
                          : tab
                      }`
                    )
                  "
                >
                  <DesktopTabContainer :component-name="tab" />
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
      </b-container>

      <b-row class="justify-content-center fill-width">
        <b-col
          cols="9"
          class="d-flex justify-content-center align-items-center"
        >
          <b-container
            class="base-container d-flex justify-content-center align-items-center direction-rtl dynamic-min-height min-width-94vw"
            fluid
          >
            <router-view name="newVersionBody"></router-view>
          </b-container>
        </b-col>
      </b-row>
    </template>
    <!--    mobile container-->
    <b-container
      v-if="!noGateWayActive && mobileSize"
      fluid
      class="base-container direction-rtl"
    >
      <b-row v-if="!getGlobalApiRequestPending">
        <b-col
          cols="12"
          align-self="center"
          class="navigation-background rounded-pill p-1"
        >
          <b-row class="mr-1">
            <div class="scroll-x-container">
              <b-col
                @click="goTo('/')"
                :cols="getIsCompName === 'shetab' ? 4 : 2"
                align-self="center"
                class="pr-2 rounded-pill expanding-element"
                v-if="whichGateAway.includes('shetab')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'shetab',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'shetab' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'shetab',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/shetab-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects': getIsCompName === 'shetab',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'shetab'"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("shetab") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <b-col
                @click="goTo('/perfect-money')"
                :cols="getIsCompName === 'perfectMoney' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('perfect-money')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'perfectMoney',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'perfectMoney' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'perfectMoney',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/perfect-money-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects': getIsCompName === 'perfectMoney',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'perfectMoney'"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("perfectMoney") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <b-col
                @click="goTo('/vouchers')"
                :cols="getIsCompName === 'vouchers' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('vouchers')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'vouchers',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'vouchers' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'vouchers',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/vouchers.png')"
                      class="rounded-pill mix-blend-mode-luminosity max-width-45px max-height-45px ml-1"
                      :class="{
                        'active-tab-effects': getIsCompName === 'vouchers',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'vouchers'"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("vouchers") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <!-- <b-col
                @click="goTo('/ctc')"
                :cols="getIsCompName === 'cardToCard' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('cardToCard')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'cardToCard',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'cardToCard' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'cardToCard',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/c2c-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects': getIsCompName === 'cardToCard',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'cardToCard'"
                    >
                      <span class="font-size-small font-weight-bold">
                        کارت به کارت
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col> -->

              <!-- <b-col
                @click="goTo('/indirect')"
                :cols="getIsCompName === 'accountToAccount' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('accountToAccount')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'accountToAccount',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'accountToAccount' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start':
                        getIsCompName === 'accountToAccount',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/account-to-account.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects':
                          getIsCompName === 'accountToAccount',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'accountToAccount'"
                    >
                      <span class="font-size-small font-weight-bold">
                        حساب به حساب
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col> -->

              <b-col
                @click="goTo('/indirect')"
                :cols="indirectGroupActive ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="
                  whichGateAway.includes('accountToAccount') ||
                  whichGateAway.includes('cardToCard')
                "
                :class="{
                  'pr-2 background-white': indirectGroupActive,
                }"
              >
                <b-row>
                  <b-col
                    :cols="indirectGroupActive ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': indirectGroupActive,
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/account-to-account.png')"
                      class="rounded-pill mix-blend-mode-luminosity max-width-45px"
                      :class="{
                        'active-tab-effects': indirectGroupActive,
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-2"
                      v-if="indirectGroupActive"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("indirect") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <!-- 
              <b-col
                @click="goTo('/tether')"
                :cols="getIsCompName === 'tether' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('tether')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'tether',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'tether' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'tether',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/tether-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects': getIsCompName === 'tether',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'tether'"
                    >
                      <span class="font-size-small font-weight-bold">
                        درگاه تتر
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
              <b-col
                @click="goTo('/tron')"
                :cols="getIsCompName === 'tron' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('tron')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'tron',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'tron' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'tron',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/tron-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity max-width-40px"
                      :class="{
                        'active-tab-effects': getIsCompName === 'tron',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'tron'"
                    >
                      <span class="font-size-small font-weight-bold">
                        ترون
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col> -->
              <b-col
                @click="goTo('/crypto-group')"
                :cols="cryptoGroupActive ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="
                  whichGateAway.includes('tron') ||
                  whichGateAway.includes('tether')
                "
                :class="{
                  'pr-2 background-white': cryptoGroupActive,
                }"
              >
                <b-row>
                  <b-col
                    :cols="cryptoGroupActive ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': cryptoGroupActive,
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/crypto-group.png')"
                      class="rounded-pill mix-blend-mode-luminosity max-width-45px"
                      :class="{
                        'active-tab-effects': cryptoGroupActive,
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-2"
                      v-if="cryptoGroupActive"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("crypto") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>

              <b-col
                @click="goTo('/shaparak')"
                :cols="getIsCompName === 'shaparak' ? 4 : 2"
                align-self="center"
                class="rounded-pill expanding-element"
                v-if="whichGateAway.includes('shaparak')"
                :class="{
                  'pr-2 background-white': getIsCompName === 'shaparak',
                }"
              >
                <b-row>
                  <b-col
                    :cols="getIsCompName === 'shaparak' ? 4 : 12"
                    align-self="center"
                    class="d-flex justify-content-center p-0"
                    :class="{
                      'justify-content-start': getIsCompName === 'shaparak',
                    }"
                  >
                    <b-img
                      :src="require('@/assets/images/shaparak-icon.png')"
                      class="rounded-pill mix-blend-mode-luminosity"
                      :class="{
                        'active-tab-effects': getIsCompName === 'shaparak',
                      }"
                      fluid
                    />
                  </b-col>
                  <transition
                    name="animate__slideInRight"
                    enter-active-class="animate__animated animate__fadeIn"
                    appear
                  >
                    <b-col
                      cols="8"
                      align-self="center"
                      class="d-flex justify-content-start px-0"
                      v-if="getIsCompName === 'shaparak'"
                    >
                      <span class="font-size-small font-weight-bold">
                        {{ $translate("shaparak") }}
                      </span>
                    </b-col>
                  </transition>
                </b-row>
              </b-col>
            </div>
          </b-row>
        </b-col>
      </b-row>
      <router-view name="newVersionBody"></router-view>
    </b-container>
    <!--    loading container-->
    <b-container
      class="d-flex justify-content-center align-items-center"
      v-if="getVersion === 'v1' && getGatewayPendingFlag"
    >
      <div id="preloader">
        <div id="ctn-preloader" class="ctn-preloader">
          <div class="round_spinner">
            <div class="spinner"></div>
            <div class="text">
              <img src="@/assets/images/Logo-2.png" alt="Caspian" />
            </div>
          </div>
          <!--          <h2 class="head">Caspian payment</h2>
                    <p>You can connect any type of gateways to caspian payment</p>-->
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { paymentMixin } from "@/mixins/PaymentMixin";
import DesktopTabContainer from "@/components/Payment/Helper/DesktopTabContainer";

export default {
  name: "PaymentNewVersion",
  components: { DesktopTabContainer },
  mixins: [paymentMixin],
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    cryptoGroupActive() {
      return ["tether", "tron", "cryptoGroup"].includes(this.getIsCompName);
    },
    indirectGroupActive() {
      return ["accountToAccount", "cardToCard", "indirectGroup"].includes(
        this.getIsCompName
      );
    },
    filteredGateways() {
      // Check if both 'tether' and 'tron' are present and keep only one instance as 'cryptoGroup'
      const hasCryptoGroup =
        this.whichGateAway.includes("tether") ||
        this.whichGateAway.includes("tron") ||
        this.whichGateAway.includes("tether-bep20") ||
        this.whichGateAway.includes("vatan-erc20") ||
        this.whichGateAway.includes("tether-erc20");

      // Check if both 'accountToAccount' and 'cardToCard' are present and keep only one instance as 'indirectGroup'
      const hasIndirectGroup =
        this.whichGateAway.includes("accountToAccount") ||
        this.whichGateAway.includes("cardToCard");

      return this.whichGateAway
        .filter(
          (tab) =>
            tab !== "tether" &&
            tab !== "tron" &&
            tab !== "tether-bep20" &&
            tab !== "tether-erc20" &&
            tab !== "vatan-erc20" &&
            tab !== "accountToAccount" &&
            tab !== "cardToCard"
        )
        .concat(hasCryptoGroup ? ["cryptoGroup"] : [])
        .concat(hasIndirectGroup ? ["indirectGroup"] : []);
    },
  },
};
</script>

<style scoped>
.dynamic-min-height {
  min-height: 25vh;
}
@media (max-height: 1300px) {
  .dynamic-min-height {
    min-height: 30vh;
  }
}
@media (max-height: 1000px) {
  .dynamic-min-height {
    min-height: 35vh;
  }
}
.tab-container-width {
  max-width: 95vw !important;
  min-width: 95vw;
}
/*.min-width-94vw {*/
/*  min-width: 78vw;*/
/*  max-width: 78vw !important;*/
/*  !*min-width: 94vw;*!*/
/*}*/
.max-width-40px {
  max-width: 40px !important;
}
.max-width-45px {
  max-width: 45px !important;
}
.max-height-45px {
  max-height: 45px !important;
  min-height: 45px !important;
}
.custom-tab-col {
  flex: 0 0 16.666%; /* This makes the custom column 16% the width of a standard column */
}
/*!* Large (lg) *!*/
/*@media (min-width: 992px) {*/
/*  .custom-tab-col {*/
/*    flex: 0 0 15%; !* One-quarter width for large screens *!*/
/*  }*/
/*}*/
/*!* Extra Large (xl) *!*/
/*@media (min-width: 1200px) {*/
/*  .custom-tab-col {*/
/*    flex: 0 0 14%; !* One-fifth width for extra-large screens *!*/
/*  }*/
/*}*/
/*@media (min-width: 1600px) {*/
/*  .custom-tab-col {*/
/*    flex: 0 0 12%; !* One-fifth width for extra-large screens *!*/
/*  }*/
/*}*/
.base-container {
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 10px 30px 0 rgba(43, 55, 86, 0.06);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-inline: 20px;
}
.expanding-element {
  transition: width 0.5s ease-in-out; /* Adjust the duration and easing as needed */
  height: 100%;
}
.scroll-x-container {
  width: 98%;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 5px;
  /* Hide the default scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.scroll-x-container::-webkit-scrollbar {
  width: 0; /* Hide the scrollbar for Chrome, Safari, and Opera */
  height: 0; /* Hide the scrollbar for Chrome, Safari, and Opera */
}
.active-tab-effects {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  mix-blend-mode: normal !important;
}

.paymentButtonActive {
  background-image: linear-gradient(to right, #01bd64, #3b9eea);
  width: 125px;
  border-radius: 5px;
  color: white;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  height: 50px;
}

.secondVersionMainContainer {
  background-color: rgb(235, 243, 251) !important;
}

.newBadgeClass {
  position: absolute !important;
  left: 10% !important;
  top: 2% !important;
}

#preloader {
  background: #ccdde7;
  height: 100%;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#preloader .ctn-preloader {
  padding-left: 15px;
  padding-right: 15px;
}

#preloader .round_spinner {
  border-width: 1px;
  border-color: #eef3f4;
  border-style: solid;
  border-radius: 50%;
  background-color: #fdfdfd;
  /*box-shadow: 0 0 100px 0 rgb(4 46 56);*/
  width: 248px;
  height: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 40px auto 80px;
}

#preloader .spinner:before {
  content: "";
  width: 20px;
  height: 20px;
  border: 6px solid #fff;
  box-shadow: 0 0 20px 0 rgba(4, 46, 56, 0.2);
  background: #0050b2;
  position: absolute;
  right: 31px;
  top: 41px;
  border-radius: 50%;
}

@media (max-width: 576px) {
  #preloader .spinner:before {
    top: 18px;
  }
}

#preloader .spinner {
  animation: spinner 3s infinite linear;
  border-radius: 50%;
  border: 3px solid #f1f6f8;
  border-left-color: #0050b2;
  border-top-color: #0050b2;
  margin: 0 auto 0em auto;
  position: absolute;
  left: -40px;
  right: -40px;
  bottom: -40px;
  top: -40px;
}

#preloader .head {
  color: #171d24;
  display: block;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 5.2px;
  text-transform: uppercase;
  text-align: center;
  font-family: "Roboto", sans-serif;
  margin: 5% 0 1% 0;
  padding: 0;
}

#preloader p {
  color: #6a737c;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  border: none;
  margin: 0;
  padding: 0;
}

@keyframes spinner {
  to {
    transform: rotateZ(360deg);
  }
}

@media (max-width: 576px) {
  #preloader .round_spinner {
    width: 155px;
    height: 155px;
  }
}

#preloader .round_spinner h4 {
  font-size: 30px;
  font-weight: 400;
  margin-bottom: 0;
  color: #171d24;
  margin-top: 10px;
}

#preloader .round_spinner h4 span {
  font-weight: 700;
}

/*opacity animation for the newBadge*/
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.flickerAnimationClass {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}

.margin-left-top-5 {
  margin-top: 5%;
  margin-left: 5%;
}

@media only screen and (max-width: 1450px) and (min-width: 1200px) and (max-height: 992px) and (min-height: 576px) {
  #mainContainer {
    max-width: 1025px !important;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 992px) {
  .tabs {
    padding: 35px 35px;
  }
}

@media only screen and (max-width: 992px) {
  .margin-left-top-5 {
    margin-top: 5% !important;
    margin-left: 0 !important;
  }

  .paymentButtons {
    width: 100%;
    border-radius: 15px;
    background-color: #6c6c6c;
    border: none;
    color: #c7c3c3;
    height: 40px;
    font-size: 0.9rem;
  }

  .paymentButtonActive {
    background-image: linear-gradient(to right, #01bd64, #3b9eea);
    width: 100%;
    border-radius: 5px;
    color: white;
    border: none;
    font-size: 0.9rem;
    font-weight: bold;
    height: 40px;
  }

  img.ordinary-img {
    width: 45px !important;
    height: 50px !important;
  }

  .tabs {
    padding: 5px;
  }

  .activeTab {
    border-top: 5px solid midnightblue;
    border-right: none;
  }

  .tabs {
    border-left: 2px solid lightgray;
    border-bottom: none;
  }
}

@media only screen and (max-width: 575px) {
  img.ordinary-img {
    width: 35px !important;
    height: 35px !important;
  }
}
</style>
